import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, onMounted, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import { fetchCurrentUserQuotaUsages } from "@/api/users";
import { useConfig } from "@/composables/config";
import { useTaskMonitor } from "@/composables/taskMonitor";
import { useUserStore } from "@/stores/userStore";
import { errorMessageAsString } from "@/utils/simple-error";
import { bytesToString } from "@/utils/utils";
import QuotaUsageSummary from "@/components/User/DiskUsage/Quota/QuotaUsageSummary.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DiskUsageSummary',
    setup(__props) {
        const { config, isConfigLoaded } = useConfig(true);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        const { isRunning: isRecalculateTaskRunning, waitForTask } = useTaskMonitor();
        const quotaUsages = ref();
        const errorMessage = ref();
        const isRecalculating = ref(false);
        const niceTotalDiskUsage = computed(() => {
            if (!currentUser.value || currentUser.value.isAnonymous) {
                return "Unknown";
            }
            return bytesToString(currentUser.value.total_disk_usage, true);
        });
        const isRefreshing = computed(() => {
            return isRecalculateTaskRunning.value || isRecalculating.value;
        });
        watch(() => isRefreshing.value, (newValue, oldValue) => {
            // Make sure we reload the user and the quota usages when the recalculation is done
            if (oldValue && !newValue) {
                const includeHistories = false;
                userStore.loadUser(includeHistories);
                loadQuotaUsages();
            }
        });
        async function displayRecalculationForSeconds(seconds) {
            return new Promise((resolve) => {
                isRecalculating.value = true;
                setTimeout(() => {
                    isRecalculating.value = false;
                    resolve();
                }, seconds * 1000);
            });
        }
        async function onRefresh() {
            const { response, data, error } = await GalaxyApi().PUT("/api/users/current/recalculate_disk_usage");
            if (error) {
                errorMessage.value = errorMessageAsString(error);
                return;
            }
            if (response.status == 200) {
                // Wait for the task to complete
                const asyncTaskResponse = data;
                waitForTask(asyncTaskResponse.id);
            }
            else if (response.status == 204) {
                // We cannot track any task, so just display the
                // recalculation message for a reasonable amount of time
                await displayRecalculationForSeconds(30);
            }
        }
        async function loadQuotaUsages() {
            try {
                const currentUserQuotaUsages = await fetchCurrentUserQuotaUsages();
                quotaUsages.value = currentUserQuotaUsages;
            }
            catch (error) {
                errorMessage.value = errorMessageAsString(error);
            }
        }
        onMounted(async () => {
            await loadQuotaUsages();
        });
        return { __sfc: true, config, isConfigLoaded, userStore, currentUser, isRecalculateTaskRunning, waitForTask, quotaUsages, errorMessage, isRecalculating, niceTotalDiskUsage, isRefreshing, displayRecalculationForSeconds, onRefresh, loadQuotaUsages, QuotaUsageSummary };
    }
});
